import React from 'react'
import Icon from '../../icon'
import { IAction } from '../../../interfaces/table'

import { Container, Button } from './styles'
import Tooltip from '../../tooltip'

type IProps = {
  item: any;
  data: IAction[];
}

const Actions = ({ data, item }: IProps) => {
  const handleAction = (action: any) => {
    action.handler(item)
  }

  return (
    <Container>
      {
        data.map((action) => (
          <Tooltip
            key={action.icon}
            color={action.color}
            text={action.text}
          >
            <Button
              onClick={() => handleAction(action)}
              hoverColor={action.hoverColor || ''}
            >
              <Icon name={action.icon} />
            </Button>
          </Tooltip>
        ))
      }
    </Container>
  )
}
export default Actions
